enum FinancingParameterTypeEnum
{
    BASE = "BASE",
    RESIDUAL_VALUE = "RESIDUAL_VALUE",
    EARNING = "EARNING",
    EARLY_REPAYMENT_FEE = "EARLY_REPAYMENT_FEE",
    EXCESSIVE_WEAR_FEE = "EXCESSIVE_WEAR_FEE",
}

export default FinancingParameterTypeEnum;
